import { connect } from 'react-redux';
import TermsOfService from './TermsOfService';
import States from 'login-constants/states';
import * as routingUtils from 'login-utils/routingUtils';
import { acceptTerms } from 'login-actions/termsOfServiceActions';

const mapDispatchToProps = dispatch => {
  return {
    onSubmit: evt => {
      evt.preventDefault();
      dispatch(acceptTerms());
      routingUtils.pushWithContext(States.LOAN_ESTIMATE);
    },
  };
};

export default connect(undefined, mapDispatchToProps)(TermsOfService);
